import React from "react";
import { useNavigate } from "react-router-dom";
import Section from "../components/Section";
import "../styles/Home.css";

type Product = {
  title: string;
  id: string;
  image: string;
  status: "available" | "coming soon";
};

type ProductGroup = {
  title: string;
  products: Product[];
};

const Home: React.FC = () => {
  const navigate = useNavigate();

  const data: ProductGroup[] = [
    {
      title: "NEW",
      products: [
        {
          title: "Marvel Rivals",
          id: "marvel_rivals",
          image:
            "https://cdn1.codashop.com/S/content/mobile/images/product-tiles-plain/MarvelRivals_tile178x178.jpg",
          status: "coming soon",
        },
        {
          title: "Honor of Kings",
          id: "honor_of_kings",
          image:
            "https://cdn1.codashop.com/S/content/mobile/images/product-tiles-plain/Honor-of-Kings-Tile.png",
          status: "coming soon",
        },
        {
          title: "Yalla Ludo",
          id: "yalla_ludo",
          image:
            "https://cdn1.codashop.com/S/content/mobile/images/product-tiles/yallaludo_tile.png",
          status: "coming soon",
        },
        {
          title: "Chamet",
          id: "chamet",
          image:
            "https://cdn1.codashop.com/S/content/mobile/images/product-tiles-plain/Chamet-tile_178x178.jpg",
          status: "coming soon",
        },
        {
          title: "Watcher of Realms",
          id: "watcher_of_realms",
          image:
            "https://cdn1.codashop.com/S/content/mobile/images/product-tiles/watcher_of_realms_tile.png",
          status: "coming soon",
        },
        {
          title: "Culinary Tour",
          id: "culinary_tour",
          image:
            "https://cdn1.codashop.com/S/content/mobile/images/product-tiles/culinary_tour.png",
          status: "coming soon",
        },
      ],
    },
    {
      title: "DIRECT TOP UP",
      products: [
        {
          title: "Westward Adventure",
          id: "westward_adventure",
          image:
            "https://cdn1.codashop.com/S/content/mobile/images/product-tiles/westward-tile.png",
          status: "coming soon",
        },
        {
          title: "Time Raiders",
          id: "time_raiders",
          image:
            "https://cdn1.codashop.com/S/content/mobile/images/product-tiles/timeraiders_tile.png",
          status: "coming soon",
        },
        {
          title: "Bigo Live",
          id: "bigo_live",
          image:
            "https://cdn1.codashop.com/S/content/mobile/images/product-tiles/bigo_live_tile.jpg",
          status: "coming soon",
        },
        {
          title: "Stumble Guys",
          id: "stumble_guys",
          image:
            "https://cdn1.codashop.com/S/content/mobile/images/product-tiles/Stumble_Guys_Tile.png",
          status: "coming soon",
        },
      ],
    },
    {
      title: "VOUCHERS",
      products: [
        {
          title: "Twitch",
          id: "twitch",
          image:
            "https://cdn1.codashop.com/S/content/mobile/images/product-tiles/twitchtds_tile.jpg",
          status: "coming soon",
        },
        {
          title: "Netflix",
          id: "netflix",
          image:
            "https://cdn1.codashop.com/S/content/mobile/images/product-tiles/netflixtds_tile.jpg",
          status: "coming soon",
        },
        {
          title: "Airbnb",
          id: "airbnb",
          image:
            "https://cdn1.codashop.com/S/content/mobile/images/product-tiles/airbnbtds_tile.jpg",
          status: "coming soon",
        },
        {
          title: "Uber",
          id: "uber",
          image:
            "https://cdn1.codashop.com/S/content/mobile/images/product-tiles/ubertds_tile.jpg",
          status: "coming soon",
        },
        {
          title: "DoorDash",
          id: "doordash",
          image:
            "https://cdn1.codashop.com/S/content/mobile/images/product-tiles/doordashtds_tile.jpg",
          status: "coming soon",
        },
      ],
    },
  ];

  const handleProductClick = (id: string) => {
    navigate(`/details/${id}`);
  };

  return (
    <div className="home">
      {data.map((group) => (
        <Section
          key={group.title}
          title={group.title}
          products={group.products}
          onProductClick={handleProductClick}
        />
      ))}
    </div>
  );
};

export default Home;
